import moment from 'moment-timezone';

export const showDirectionsToEventLocation = event => {
    const startTime = moment
        .utc(event.startTime)
        .subtract(event.showDirectionsFromHrsBeforeStart, 'hours');
    return !moment().isBefore(startTime);
};
